import FooterIcetex from '../../components/footerIcetex/footerIcetex';
import HeaderIcetex from '../../components/headerIcetex/headerIcetex';
import { ILayout } from '../../../shared/types/latyout';

export function LayoutIcetex({ children }: ILayout) {
    return (
        <div>
            <HeaderIcetex />
            {children}
            <FooterIcetex />
        </div>
    );
}
